import React, { useState, useEffect } from 'react';
import { ApiSearchGroupItem } from './ApiSearchGroupItem';
import { searchParams } from '../../../../utils/data-utils';
import { Card } from "cdk-radial";

export const getSearchItems = (searchItems, allSearchItems) => {
  let locAllSearchItems = {};
  const searchKey = Object.keys(searchItems)[0];

  locAllSearchItems = JSON.parse(JSON.stringify(allSearchItems));
  locAllSearchItems[searchKey] = {
    ...locAllSearchItems[searchKey],
    ...searchItems[searchKey]
  };
  return locAllSearchItems;
};

export const ApiSearchGroup = ({
  domains,
  setSearchFilters,
  selectedDomainIds,
  selectedApiType,
  selectedOrgs,
  belongsTo,
  sendAmplitudeData,
  bundles,
  apis,
  selectedFilterType,
  apiHomeOnClickHandlers
}) => {
  const [allSearchItems, setAllSearchItems] = useState({});
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    let searchFilters = JSON.parse(JSON.stringify(searchParams))
        let hasBundles = false;

        if (bundles?.length) {
          hasBundles = true;
        }

        const hasContractedApis = 
        (Array.isArray(apis) && apis.some(api => api.isContracted)) ||
        (Array.isArray(bundles) && bundles.some(bundle => bundle.isContracted));
        if (hasBundles || hasContractedApis) {
          let values = []
          if (hasBundles)
            values.push({
              key: 'Bundles',
              value: 'Bundles'
            })
          if (hasContractedApis)
            values.push({
              key: 'Contracted',
              value: 'Contracted'
            })

          searchFilters = {
            filters: {
              text: 'API Group',
              values: values
            },
            ...searchFilters,
          };
        }
    if (!!domains?.items) {
      setFilters({
        ...searchFilters,
        category: {
          text: 'Categories',
          values: createFilters(domains, 'Categories')
        }
      });
    }
  }, [domains, bundles,apis]);

  useEffect(() => {
    const apiTypeSet = {
      'REST': 'restApi',
      'Async': 'asyncApi',
      Bundles: 'bundles'
    };

    if (
      !!selectedDomainIds &&
      !!selectedApiType &&
      !!selectedOrgs &&
      !!allSearchItems &&
      !!selectedFilterType
    ) {
      const locSelectedApiType = Array.isArray(selectedApiType)
        ? selectedApiType
        : [selectedApiType];
      const locApiTypes = !!allSearchItems['apiType']
        ? Object.keys(allSearchItems['apiType']).filter(
          f => allSearchItems['apiType'][f]
        )
        : [];
      const locCategories = !!allSearchItems['category']
        ? Object.keys(allSearchItems['category']).filter(
          f => allSearchItems['category'][f]
        )
        : [];
      const locOrgs = !!allSearchItems['org']
        ? Object.keys(allSearchItems['org']).filter(
          f => allSearchItems['org'][f]
        )
        : [];

      const propsApiTypes = locSelectedApiType.map(m => apiTypeSet[m]);

      const locFilterTypes = !!allSearchItems['filters']
      ? Object.keys(allSearchItems['filters']).filter(
        f => allSearchItems['filters'][f]
      )
      : [];

      if (
        JSON.stringify(locApiTypes) !== JSON.stringify(propsApiTypes) ||
        JSON.stringify(locCategories) !== JSON.stringify(selectedDomainIds) ||
        JSON.stringify(locOrgs) !== JSON.stringify(selectedOrgs) ||
        JSON.stringify(locFilterTypes) !== JSON.stringify(selectedFilterType)
      ) {
        let locObjApiType = {};
        let locObjCategories = {};
        let locObjOrgs = {};
        let locObjFilterType= {};

        propsApiTypes.forEach(
          f => (locObjApiType = { ...locObjApiType, [f]: true })
        );
        !!selectedDomainIds &&
          Array.isArray(selectedDomainIds) &&
          selectedDomainIds.forEach(
            f => (locObjCategories = { ...locObjCategories, [f]: true })
          );
        !!selectedOrgs &&
          Array.isArray(selectedOrgs) &&
          selectedOrgs.forEach(
            f => (locObjOrgs = { ...locObjOrgs, [f]: true })
          );
          !!selectedFilterType &&
          Array.isArray(selectedFilterType) &&
          selectedFilterType.forEach(
            f => (locObjFilterType = { ...locObjFilterType, [f]: true })
          );
        const localAllSearchItems = {
          apiType: locObjApiType,
          category: locObjCategories,
          org: locObjOrgs,
          filters: locObjFilterType
        };
        setAllSearchItems(localAllSearchItems);
        setSearchFilters(localAllSearchItems);
      }
    }
  }, [selectedDomainIds, selectedApiType, selectedOrgs, allSearchItems]);

  const createFilters = (domains, type) => {
    const domainTypes = {
      Categories: 'CATEGORIES',
      Publishers: 'PROVIDERS'
    };
    let filterArr = [];

    const localFilters = domains.items.filter(
      f => f.name.toUpperCase() === domainTypes[type]
    )[0]?.dimensions;

    localFilters.forEach(
      f => (filterArr = [...filterArr, { key: f.id, value: f.name }])
    );

    return filterArr;
  };

  const handleSetSearchItems = searchItems => {
    const locAllSearchItems = getSearchItems(searchItems, allSearchItems);
    setAllSearchItems(locAllSearchItems);
    setSearchFilters(locAllSearchItems);
  };

  const getSelectedFilters = searchKey => {
    let searchFilters = [];
    switch (searchKey) {
      case 'apiType':
        searchFilters = selectedApiType;
        break;
      case 'category':
        searchFilters = selectedDomainIds;
        break;
      case 'filters':
        searchFilters = selectedFilterType;
        break;
      default:
        searchFilters = selectedOrgs;
        break;
    }
    return searchFilters;
  };

  return (
      <Card>
        <div className="api-dir-pkg_search-group-filter">FILTER BY</div>
        <div className="api-dir-pkg_search-group-border" />
        <ul className="api-dir-pkg_search-group-items">
          {Object.keys(filters).map((m, sId, arr) => (
            <div key={sId}>
              <ApiSearchGroupItem
                keyId={sId}
                searchParams={filters[m]}
                searchKey={m}
                belongsTo={belongsTo}
                selectedFilters={getSelectedFilters(m)}
                setSearchFilters={handleSetSearchItems.bind(this)}
                sendAmplitudeData={sendAmplitudeData}
                apiHomeOnClickHandlers={apiHomeOnClickHandlers}
              />
              {sId !== arr.length - 1 && <div className="api-dir-pkg_search-group-border" />}
            </div>
          ))}
        </ul>
      </Card>
  );
};
